export default __webpack_public_path__ + "static/guitar-267052ea487e2edb51a05ecd2388e73b.png";